var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-title bb1",style:(_vm.style)},[_c('p',{staticClass:"p"},[_c('AIcon',{attrs:{"type":_vm.icon}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1),_c('div',{staticClass:"right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }